import React from 'react';
import { navigate } from '@reach/router';

import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

const CaseInfoContent = ({ referrals = [], requests = [], rfqs = [], users = [] }) => {

    console.log('CaseInfoContent', rfqs)

    const handleClick = ({ intermediaryId, bookingReference = '' }) => {
        navigate(`/casework/info/${intermediaryId}?filter=${bookingReference}`);
    }

    return (
        <div>
            {
                referrals.map(({ id: referralId, bookingReference = 'WTAF!' }) => {

                    const { message = '', organization = '' } = requests.find(request => request.referralId === referralId) || {};

                    return (
                        <Grid key={referralId} container direction="column" spacing={1}>
                            <Grid item>
                                <Typography variant="h6" color="initial">Booking Reference {bookingReference}</Typography>
                                <Typography variant="subtitle2" color="textSecondary">{organization}</Typography>
                                <Typography variant="subtitle2" color="textSecondary">{message}</Typography>
                            </Grid>
                            <Typography variant="h6" color="initial">Quotes requested from</Typography>
                            {
                                rfqs
                                    .filter(rfq => rfq.referralId === referralId)
                                    .map(({ id: rfqId, intermediaryId, status = '' }) => {
                                        const { name = '' } = users.find(({ id: userId }) => userId === intermediaryId) || {};
                                        return <Grid item key={`${rfqId}${intermediaryId}`}>
                                            <Button variant="text" color="primary" onClick={() => handleClick({ intermediaryId, bookingReference })}>
                                                {name} {status !== 'new' ? `(${status})` : ''}
                                            </Button>
                                        </Grid>
                                    })
                            }
                        </Grid>
                    );
                })
            }
        </div>
    );
}

export default CaseInfoContent;